import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { FieldConfig } from '../../models/common-models';
import { Field } from '../../models/field.interface';

@Component({
    selector: 'app-form-time',
    templateUrl: './form-time.component.html',
    styleUrls: ['./form-time.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class FormTimeComponent implements Field, OnInit, OnDestroy {
  public FormControlName;
  config: FieldConfig;
  group: UntypedFormGroup;
  _minDate: Date;
  today = new Date();
  hideTodayButton: boolean = false;
  subscriptions: Subscription = new Subscription();
  constructor() { }

  ngOnInit(): void {
    return;
  }

  ngOnDestroy(): void {
    if (this.subscriptions) { this.subscriptions.unsubscribe(); }
  }
}

